var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"pic-cell",attrs:{"src":_vm.item.img,"cover":""},on:{"click":_vm.onclick}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/practice/company/pic-cell.vue?vue&type=template&id=6d958ae2&scoped=true
// module id = null
// module chunks = 